export const LOADER_MUNICIPALITYUSER             =    'LOADER_MUNICIPALITYUSER';
export const GET_MUNICIPALITYUSER                =    'GET_MUNICIPALITYUSER';
export const MUNICIPALITYUSER_FAIL               =    'MUNICIPALITYUSER_FAIL';
export const SAVE_LOADER_MUNICIPALITYUSER        =    'SAVE_LOADER_MUNICIPALITYUSER';
export const FORM_MUNICIPALITYUSER_FAIL          =    'FORM_MUNICIPALITYUSER_FAIL';

